export const UserTypes = {
  DASHBOARD_ADMIN_ID: 1,
  DASHBOARD_USER_ID: 2,
  DIRECT_DELEGATE_ID: 8,
  PUBLIC_USER_ACCOUNT: 9,
  AGENT_ENTITY_ID: 10,
  AGENT_OWNER_ACCOUNT_ID: 11,
  AGENT_USER_ID: 12,
  DIRECT_MERCHANT_ID: 20,
  MERCHANT_OWNER_ACCOUNT: 21,
  DIRECT_MERCHANT_USER_ID: 22,
};
